import React, { useState } from 'react';
import { FiMapPin, FiMail, FiPhone, FiSend } from 'react-icons/fi';
import './CTA.css';

const CTA = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Static for now - will be dynamic later
    alert('Terima kasih! Pesan Anda telah terkirim. Kami akan menghubungi Anda segera.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <section className="cta section" id="kontak">
      <div className="container">
        <div className="cta__container">
          <div className="cta__info">
            <h2 className="cta__title">Mulai Transformasi Anda</h2>
            <p className="cta__description">
              Tim kami siap membantu Anda menemukan solusi terbaik 
              untuk kebutuhan infrastruktur IT perusahaan Anda.
            </p>

            <div className="cta__contacts">
              <div className="cta__contact-item">
                <div className="cta__contact-icon">
                  <FiMapPin size={18} />
                </div>
                <div className="cta__contact-text">
                  <span className="cta__contact-label">Kantor Pusat</span>
                  <span className="cta__contact-value">
                    Jl. Teknologi No. 123, Jakarta Selatan, DKI Jakarta 12345
                  </span>
                </div>
              </div>

              <div className="cta__contact-item">
                <div className="cta__contact-icon">
                  <FiMail size={18} />
                </div>
                <div className="cta__contact-text">
                  <span className="cta__contact-label">Email</span>
                  <span className="cta__contact-value">info@sjt.co.id</span>
                </div>
              </div>

              <div className="cta__contact-item">
                <div className="cta__contact-icon">
                  <FiPhone size={18} />
                </div>
                <div className="cta__contact-text">
                  <span className="cta__contact-label">Telepon</span>
                  <span className="cta__contact-value">+62 21 1234 5678</span>
                </div>
              </div>
            </div>
          </div>

          <div className="cta__form-wrapper">
            <h3 className="cta__form-title">Kirim Pesan</h3>
            <form className="cta__form" onSubmit={handleSubmit}>
              <div className="cta__form-group">
                <label htmlFor="name" className="cta__form-label">Nama Lengkap</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="cta__form-input"
                  placeholder="Masukkan nama Anda"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="cta__form-group">
                <label htmlFor="email" className="cta__form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="cta__form-input"
                  placeholder="nama@perusahaan.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="cta__form-group">
                <label htmlFor="subject" className="cta__form-label">Subjek</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="cta__form-input"
                  placeholder="Topik pesan Anda"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="cta__form-group">
                <label htmlFor="message" className="cta__form-label">Pesan</label>
                <textarea
                  id="message"
                  name="message"
                  className="cta__form-input cta__form-textarea"
                  placeholder="Ceritakan kebutuhan Anda..."
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary cta__form-submit">
                <FiSend size={16} /> Kirim Pesan
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
